var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$route.meta && _vm.$route.meta.moduleId || '',attrs:{"id":"app"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"layer-loading"},[_c('i'),_c('i'),_c('i')]),_c('router-view',{on:{"login":_vm.queryPermissions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }